const mTheHeaderSubMenu = {
  mTheHeaderSubMenu: {
    tooltipComments: 'Comentarios',
    tooltipNotifications: 'Notificaciones',
    tooltipUniversity: 'Universidad'
  }
}

export default mTheHeaderSubMenu
